const BLACKLIST_URL_CHARS =
    /[[\]"'{}|^<>`]|%20|%22|%3C|%3E|%5E|%60|%7B|%7C|%7D| |\?.*?\?/;

export const checkBlacklistUrlChars = (path) => BLACKLIST_URL_CHARS.test(path);
